import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../api/auth';
import './Login.scss';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const { data, error: loginError } = await authApi.login(
      formData.email,
      formData.password
    );

    setIsLoading(false);

    if (loginError) {
      setError(loginError);
      return;
    }

    onLogin();
    navigate('/dashboard');
  };

  return (
    <div className="login">
      <div className="login__container">
        <h2>Welcome Back</h2>
        {error && <div className="login__error">{error}</div>}
        <form onSubmit={handleSubmit} className="login__form">
          <div className="login__form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="login__form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="login__button">
            Sign In
          </button>
        </form>
        <div className="login__account-question">
          Don't have an account? <span className="login__register-link"><Link to="/register">Register Here</Link></span>
        </div>
      </div>
    </div>
  );
}

export default Login; 